module.exports = __webpack_public_path__ + "static/media/wide.c222b52c.jpg";